import script from "./entrance.vue?vue&type=script&setup=true&lang=js"
export * from "./entrance.vue?vue&type=script&setup=true&lang=js"

import "./entrance.vue?vue&type=style&index=0&id=2e0fc4ce&lang=scss"

const __exports__ = script;

export default __exports__